import { Box, Button, Divider, Paper, Typography } from "@mui/material";
import { Container } from "@mui/system";
import React from "react";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { useFindMyJobApiQuery } from "../../../services/apiSlice";
import Loading from "../../Loading";
import { GetMyJobResult } from "../find-job/GetJobSearchResult";

const GetMyJob = () => {
  return (
    <Fade cascade>
      <Container>
        <Box
          className="min-h-screen"
          sx={{ mt: 5, ml: 4 }}
          style={{
            display: "flex",

            // padding: "20px",
            // margin: "4px 10px",
            flexDirection: "column",
          }}
        >
          <Divider />

          {/* <Typography
          variant="h1"
          component="h2"
          className="text-3xl  font-extrabold text-center py-12 md:py-20 "
        >
          Recommended for you
        </Typography> */}
          <SearchResult />
          <Paper
            sx={[
              {
                maxWidth: "lg",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                ml: 10,
                my: 15,
              },
              (theme) => ({
                [theme.breakpoints.down("sm")]: {
                  py: 3,
                  mx: 3,
                  ml: 3,
                },
              }),
            ]}
          >
            <Typography
              variant="p"
              component="p"
              className="md:text-md md:px-5  font-normal text-center py-8 md:py-8  "
            >
              Upgrade today to enjoy the full benefits of TOP Neigbourhood Pro's
              Premium Membership
            </Typography>
            <Link to={"/dashboard/sub-premium-plan"}>
              <Button className="text-md  font-normal text-center my-3  text-white px-5 py-6 bg-green-600 rounded-full">
                Find out more
              </Button>
            </Link>
          </Paper>
        </Box>
      </Container>
    </Fade>
  );
};

const SearchResult = (props) => {
  const { data, error, isError, isSuccess, isFetching } =
    useFindMyJobApiQuery();

  console.log({ data });

  // let AllResult;
  // if (isFetching) {
  //   AllResult = <Loading />;
  // } else if (isSuccess) {
  //   AllResult = data?.getAvailableJob;
  // } else if (isError) {
  //   AllResult = Swal.fire({
  //     icon: "error",
  //     title: "Oops...",
  //     text: error?.data?.message,
  //   });
  // }

  return (
    <div className="flex  my-20 md:ml-20 justify-center  flex-col w-full  ">
      {data?.getAvailableJob.length > 0 ? (
        <GetMyJobResult />
      ) : (
        <p className="py-4 text-center font-bold text-xs sm:text-base md:text-xl mx-3">
          No result found available
        </p>
      )}
    </div>
  );
};

export default GetMyJob;
